// @ts-nocheck
import React from 'react';

// Service
import { useSignature } from '../../../../hooks/SignatureContext';
import { useRetentionSignature } from '../../../../hooks/RetentionSignatureContext';

//Component
import Camera from '../../Cam/Cam';
import { ErrorPermissions } from '../../ScreensError/index';
import { IconErrorPermissionCam } from '../../ScreensError/svg';
import { UnicoCapturePage } from './UnicoCapture/UnicoCapturePage';

import { ContainerSelfie } from '../styles';


export const Selfie: React.FC = ({ formValues, isRetention = false }: any) => {
  const { formOpened, errorCam } = isRetention ? useRetentionSignature() : useSignature();

  /**
   * Renderiza componente baseado no tipo de fluxo
   * - isLivenessSignature === true → SDK Unico (liveness biométrico)
   * - isLivenessSignature === false → react-webcam (selfie padrão)
   */
  const isLiveness = formOpened?.isLivenessSignature === true;

  // Se há erro de câmera, mostrar error screen
  if (errorCam) {
    return (
      <ErrorPermissions
        titlePage={'Selfie'}
        cardTitle={'Sem acesso à câmera'}
        cardFooterlink={'https://support.google.com/chrome/answer/2693767?hl=pt-BR&co=GENIE.Platform%3DAndroid&oco=0'}
        cardFooterText={'Como permitir acesso à câmera'}
        icon={IconErrorPermissionCam}
      >
        Precisamos ter acesso a câmera do seu celular para tirar uma selfie e assinar a confirmar a sua assinatura.
        <br />
        <br />
        Libere acesso a câmera para continuar
      </ErrorPermissions>
    );
  }

  const selfieClassName = `banner ${isLiveness ? 'liveness-capture' : 'legacy-camera'}`;

  return (
    <ContainerSelfie className={selfieClassName}>
      {isLiveness ? (
        <UnicoCapturePage
          formValues={formValues}
          isRetention={isRetention}
        />
      ) : (
        <Camera formValues={formValues} isRetention={isRetention} />
      )}
    </ContainerSelfie>
  );
};
